import type { TOC } from '@ember/component/template-only';
import PageLoading from '../../components/page-loading.gts';

interface Signature {
  Args: {};
}

const SourcesShowLoading: TOC<Signature> = <template>
  <PageLoading
    @title="Source"
    @backRoute="sources"
    @backLabel="Back to my sources"
  />
</template>;

export default SourcesShowLoading;
